import React from 'react';

/**
 * Hand-drawn graphic language borrowed from the SMÅKEN logo's imperfect line.
 * These are annotations, not decoration — use one per module at most.
 */

interface MarkProps {
  className?: string;
  color?: string;
}

/** A loose, hand-drawn arrow. Rotate it with a wrapper if you need another direction. */
export function ArrowMark({
  className = '',
  color = 'currentColor'
}: MarkProps) {
  return <svg viewBox="0 0 120 44" fill="none" className={className} aria-hidden="true" data-id="element-669" data-mp="39kfdhmv95f7">
      <path d="M3 26c18-9 40-15 62-16 12-.5 25 0 37 3" stroke={color} strokeWidth="2.6" strokeLinecap="round" data-id="element-670" data-mp="3vey3x4pgnl38" />
      <path d="M89 3c6 4 10 7 13 10-5 3-9 7-13 12" stroke={color} strokeWidth="2.6" strokeLinecap="round" data-id="element-671" data-mp="czng6408bno3" />
    </svg>;
}

/** An imperfect circle drawn around a word, like a pen ring in a magazine. */
export function CircleMark({
  className = '',
  color = 'currentColor'
}: MarkProps) {
  return <svg viewBox="0 0 240 90" fill="none" className={className} preserveAspectRatio="none" aria-hidden="true" data-id="element-672" data-mp="i1cubsir0hge">
      <path d="M128 5C74 2 14 14 7 42c-6 25 47 44 111 43 55-1 116-15 115-42C232 18 180 7 128 5Z" stroke={color} strokeWidth="2.4" strokeLinecap="round" data-id="element-673" data-mp="2tlvdggb4ec9t" />
    </svg>;
}

/** A wobbly underline that sits beneath a headline word. */
export function UnderlineMark({
  className = '',
  color = 'currentColor'
}: MarkProps) {
  return <svg viewBox="0 0 200 14" fill="none" className={className} preserveAspectRatio="none" aria-hidden="true" data-id="element-674" data-mp="3chldhxzhsyl2">
      <path d="M2 9c34-5 68-7 101-6 33 1 63 4 95 8" stroke={color} strokeWidth="3" strokeLinecap="round" data-id="element-675" data-mp="3hfn02sw4ng1a" />
    </svg>;
}

/** A five-point star, drawn by hand. */
export function StarMark({
  className = '',
  color = 'currentColor'
}: MarkProps) {
  return <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true" data-id="element-676" data-mp="3vafji2f51gd5">
      <path d="M20 3.5 24.4 15 36.5 15.6 27.2 23.4 30.3 35.2 20 28.6 9.7 35.2 12.8 23.4 3.5 15.6 15.6 15Z" stroke={color} strokeWidth="2.2" strokeLinejoin="round" data-id="element-677" data-mp="43cwln6c1w8q" />
    </svg>;
}
interface NoteProps {
  children: React.ReactNode;
  className?: string;
}

/** A handwritten margin note. */
export function Note({
  children,
  className = ''
}: NoteProps) {
  return <span className={`font-hand text-xl leading-tight text-rod sm:text-2xl ${className}`} data-id="element-678" data-mp="253807f24mnyw">{children}</span>;
}
interface StampProps {
  children: React.ReactNode;
  className?: string;
}

/** A rotated editorial stamp, e.g. "NYTT!" or "MÅSTE TESTAS". */
export function Stamp({
  children,
  className = ''
}: StampProps) {
  return <span className={`inline-block -rotate-3 border-2 border-rod px-2.5 py-1 font-hand text-lg leading-none text-rod ${className}`} data-id="element-679" data-mp="2ss0z9ke1pbxq">
      {children}
    </span>;
}